import { Helmet } from 'react-helmet';
import { AddNewRestaurant } from '../components/AddNewRestaurant';

const AddNewRestaurantPage = () => (
  <>
    <Helmet>
      <title> Add New Restaurant</title>
    </Helmet>

    <AddNewRestaurant />
  </>
);

export default AddNewRestaurantPage;
